var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMarkerS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "80px",
    viewBox: "0 0 59 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location-marker-S") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-marker-S",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,28.9999536 C0.1041665,12.9999792 13.1333123,0 29.16662,0 C45.2624276,0 58.33324,13.0833124 58.33324,29.16662 L58.33324,29.374953 C58.1874069,53.6249142 30.9582838,77.8748754 29.2499532,79.1248734 L29.16662,79.16654 C29.16662,79.16654 0.14999976,54.4165796 0,29.374953 C0,29.2916198 0,29.2499532 0,29.16662 L0,28.9999536 Z M29.16662,16.66664 C34.9166108,16.66664 39.58327,21.3332992 39.58327,27.08329 C39.58327,32.8332808 34.9166108,37.49994 29.16662,37.49994 C23.4166292,37.49994 18.74997,32.8332808 18.74997,27.08329 C18.74997,21.3332992 23.4166292,16.66664 29.16662,16.66664 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerS);
export default __webpack_public_path__ + "static/media/location-marker-S.823d63eb88f2fac16544f7795da63db7.svg";
export { ForwardRef as ReactComponent };